var r="@hpstellar/core/content-card";export{r as contentCardTestId};
